import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from "@angular/forms";
import { PropertiesSettings } from "../../../../../core/configuration/properties-settings";
import { HelpersService } from "../../../../../core/services/helpers.service";
import { Classificazione } from "../../../../models/classificazione";
import { Argomento } from "../../../../models/tipologiche/argomento";
import { Materia } from "../../../../models/tipologiche/materia";
import { Oggetto } from "../../../../models/tipologiche/oggetto";
import { SoggettoPratica } from "../../../../models/tipologiche/soggetto-pratica";
import { TipoFascicolo } from "../../../../models/tipologiche/tipo-fascicolo";
import { TipoPratica } from "../../../../models/tipologiche/tipo-pratica";
import { ClassificazioneAdapter } from "../../classificazione/classificazione-adapter";
import { TipoVisibilita } from 'src/app/common/models/tipologiche/tipo-visibilita';
import { UserManager } from 'src/app/core/services/user-manager';
import { AppData } from 'src/app/data-store';
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { Codice } from 'src/app/common/models/tipologiche/codice';

@Component({
  selector: 'app-pratica-create-dati-classificazione-default',
  templateUrl: './pratica-create-dati-classificazione-default.component.html',
  styleUrls: ['./pratica-create-dati-classificazione-default.component.css']
})
export class PraticaCreateDatiClassificazioneDefaultComponent implements OnInit {
  @Input() praticaForm: FormGroup;
  @Input() request: any;
  @Input() classificazioneForm: FormGroup;
  @Input() newClassificazione: Classificazione;
  @Input() classificazioniCopyPratica: Classificazione[];
  @Input() idTipoPratica: string;
  @Input() idMateria: string;
  @Input() idOggetto: string;
  @Input() idArgomento: string;
  @Input() isPrimariaExist: boolean;
  @Output() create = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() createForm = new EventEmitter();
  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;

  // options
  private soggettiOptions: SoggettoPratica[] = [];
  private tipiPraticaOptions: TipoPratica[] = [];
  private tipiVisibilitaOptions: TipoVisibilita[] = [];
  private materieOptions: Materia[] = [];
  private oggettiOptions: Oggetto[] = [];
  private argomentiOptions: Argomento[] = [];
  private tipiFascicoloOptions: TipoFascicolo[] = [];
  private codiceOptions: Codice[] = [];
  tipiVisibilitaDisabled = false;
  metadataFormValid: boolean = false;
  constructor(private helpers: HelpersService) { }

  ngOnInit() {
    this.populateSelect();
  }

  populateSelect() {
    if (this.soggettiOptions.length === 0) {
      this.helpers.getSoggetti().subscribe(response => this.soggettiOptions = response);
    }
    if (this.tipiPraticaOptions.length === 0) {
      this.helpers.getTipiPratica().subscribe(response => this.tipiPraticaOptions = response);
    }
    if(AppData.getInstance().tipiVisibilitaOptions.length > 0) {
      this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
      this.checkTipoVisibilita();
    } else {
      this.helpers.getRolesByUserData().subscribe(
        () => {
          this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
          this.checkTipoVisibilita();
        }
      )
    }

    if (this.materieOptions.length === 0) {
      this.helpers.getMateria().subscribe(response => this.materieOptions = response);
    }
    if (this.oggettiOptions.length === 0 && this.idMateria) {
      this.helpers.getOggetti(this.idMateria).subscribe(response => this.oggettiOptions = response);
    }
    if (this.argomentiOptions.length === 0 && this.idMateria && this.idOggetto) {
      this.helpers.getArgomenti(this.idMateria, this.idOggetto).subscribe(response => this.argomentiOptions = response);
    }
    if (this.tipiFascicoloOptions.length === 0 && this.idTipoPratica) {
      this.helpers.getTipiFascicolo(this.idTipoPratica).subscribe(response => this.tipiFascicoloOptions = response);
    }
    if (this.codiceOptions.length === 0) {
      this.helpers.getCodice(this.idTipoPratica).subscribe(response => this.codiceOptions = response);
    }
  }

  private checkTipoVisibilita() {
    let riservato = this.tipiVisibilitaOptions.findIndex(x => x.label === 'RISERVATA') > -1;
    let riservatissimo = this.tipiVisibilitaOptions.findIndex(x => x.label === 'RISERVATISSIMA') > -1;
    if (!riservato && !riservatissimo) {
      this.tipiVisibilitaDisabled = true;
    }
  }

  setComboClassificazione(event: any, typeObj: string, newClassificazione: Classificazione) {
    let id = event.target.value;
    switch (typeObj) {
      case ('materia'):
        this.idMateria = id;
        this.idOggetto = null;
        this.idArgomento = null;
        newClassificazione.oggetto = null;
        newClassificazione.argomento = null;
        this.oggettiOptions = [];
        break;
      case ('oggetto'):
        this.idOggetto = id;
        this.idArgomento = null;
        newClassificazione.argomento = null;
        this.argomentiOptions = [];
        break;
      case ('argomento'):
        this.idArgomento = id;
        break;
    }
    this.populateSelect();
  }

  addClassificazione(newClassificazione: Classificazione) {
    newClassificazione.argomento = this.argomentiOptions.filter(a => { return a.id === this.idArgomento; })[0];
    newClassificazione.materia = this.materieOptions.filter(m => { return m.id === this.idMateria; })[0];
    newClassificazione.oggetto = this.oggettiOptions.filter(o => { return o.id === this.idOggetto; })[0];
    if (newClassificazione.isPrincipale) {
      for (let classificazione of this.request.classificazione.classificazioni) {
        if (classificazione.isPrincipale) {
          classificazione.isPrincipale = false;
        }
      }
      if (this.classificazioniCopyPratica.length > 0){
        for (let classificazioneCopy of this.classificazioniCopyPratica) {
          if (classificazioneCopy.isPrincipale) {
            classificazioneCopy.isPrincipale = false;
          }
        }
      }
    } else if (this.request.classificazione.classificazioni.length === 0 && (this.classificazioniCopyPratica.length === 0 || this.classificazioniCopyPratica.findIndex(el => el.isPrincipale === true) < 0)) {

      newClassificazione.isPrincipale = true;
    }
    this.request.classificazione.classificazioni.push(newClassificazione);
    this.newClassificazione = ClassificazioneAdapter.createClassificazione(new Classificazione());
  }

  isClassificazioneAlreadyPresent(newClassificazione: Classificazione): boolean {
    let present: boolean = false;
    if (this.request && this.request.classificazione && this.request.classificazione.classificazioni) {
      for (let classificazione of this.request.classificazione.classificazioni) {
        if (this.createStringaTipoClassificazione(classificazione) == this.createStringaTipoClassificazione(newClassificazione)) {
          present = true;
        }
      }
    }
    return present;
  }

  createStringaTipoClassificazione(classificazione: Classificazione) {
    if (!classificazione) {
      return 'NonDisponibileNonDisponibileNonDisponibile';
    }
    return (classificazione.materia && classificazione.materia.id ? classificazione.materia.id : 'NonDisponibile') +
      (classificazione.oggetto && classificazione.oggetto.id ? classificazione.oggetto.id : 'NonDisponibile') +
      (classificazione.argomento && classificazione.argomento.id ? classificazione.argomento.id : 'NonDisponibile');
  }

  removeClassificazione(index: number) {
    if (this.request.classificazione.classificazioni[index].isPrincipale) {
      this.isPrimariaExist = false;
    }
    this.request.classificazione.classificazioni.splice(index, 1);
  }

  removeClassificazioneCopy(index: number) {
    if (this.classificazioniCopyPratica[index].isPrincipale) {
      this.isPrimariaExist = false;
    }
    this.classificazioniCopyPratica.splice(index, 1);
    // this.praticaCopyInfo = null;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.pratica.metadata = value.map(value => value);
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  resetForm() {
    // Emetti l'evento per resettare il form
    this.createForm.emit();
    // Svuota i campi codice
    this.praticaForm.get('codice').patchValue(null);
    this.request.pratica.codice = null;
  }

}
